module.exports = __webpack_public_path__ + "img/IP1.ca299f8f.png";